<template>
  <div class="d-flex justify-content-center align-items-center fill-width">
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getMobileLayout">
        <b-col cols="12">
          <HeaderNewVersion />
        </b-col>
        <b-col cols="12" class="pb-1">
          <b-row v-if="getSiteRatesDisplayCondition && getSiteIdFiveCondition">
            <b-col cols="12" class="text-center new-title-color pt-3">
              {{ $translate("eachVouchersDollarBuyPrice") }}:

              <strong class="red-text">
                {{ getPerfectMoneyCurrentPrice | commaSep | persianDigit }}
              </strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="pt-3 pb-2 dodger-blue-text font-size-medium-small font-weight-bold"
            >
              <span>
                {{ $translate("onlyEnterVouchersNumber") }}
              </span>
            </b-col>
          </b-row>
          <b-container class="mb-3">
            <b-row class="flex-vertical-align mb-2 pt-2">
              <b-col cols="12" class="input-title-text new-title-color">
                {{ $translate("vouchersNumber") }}: ({{
                  $translate("characterNumber23")
                }})
              </b-col>
              <b-col cols="12">
                <b-input
                  :placeholder="$translate('enterYourVoucherNumber')"
                  class="direction-rtl new-form-control text-end py-2"
                  id="voucherNumber"
                  v-mask="'NNN-NNNN-NNNN-NNNN-NNNN-NNNN'"
                  mask="false"
                  v-model="voucherNumber"
                ></b-input>
              </b-col>
            </b-row>
            <b-container class="mt-2 px-0">
              <b-row class="flex-vertical-align mb-4 pt-3">
                <b-col cols="12" class="input-title-text new-title-color">
                  {{ $translate("securityCode") }}:
                </b-col>
                <b-col cols="12">
                  <b-input
                    :placeholder="
                      $translate('enterTheSecurityCodeInTheContainerBelow')
                    "
                    class="direction-ltr new-form-control text-end"
                    id="voucherNumber"
                    v-mask="'####'"
                    mask="false"
                    v-model="captchaInput"
                  ></b-input>
                </b-col>
              </b-row>
              <b-container class="mb-4">
                <b-row class="align-items-center justify-content-center">
                  <b-col align-self="center" cols="8">
                    <b-row
                      class="align-items-center justify-content-center captcha-row"
                    >
                      <b-col cols="10" class="d-flex justify-content-center">
                        <!--Captcha Image-->
                        <b-spinner
                          variant="primary"
                          v-if="getCaptchaImagePending"
                          class="mx-5 my-2"
                        ></b-spinner>
                        <b-img
                          width="150px"
                          :src="imageBase64"
                          v-if="!getCaptchaImagePending"
                        />
                        <!--Captcha Image-->
                      </b-col>
                      <b-col
                        cols="2"
                        class="cursor-pointer justify-content-center d-flex p-0 border-right-1px"
                        @click="getCaptchaImage"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="currentColor"
                          class="bi bi-arrow-clockwise"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                          />
                          <path
                            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                          />
                        </svg>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
              <b-row class="flex-centering pb-2">
                <b-col cols="4">
                  <button
                    type="button"
                    class="decline-button"
                    @click="cancelPayment"
                  >
                    {{ $translate("cancel") }}
                  </button>
                </b-col>
                <b-col cols="8">
                  <button
                    type="button"
                    class="btn go-to-next-button"
                    @click="submitInfo()"
                  >
                    {{ $translate("payment") }}
                  </button>
                </b-col>
              </b-row>
              <!--                <b-col class="flex-centering pb-3">-->
              <!--                  <button-->
              <!--                    type="button"-->
              <!--                    class="info-button font-weight-bold"-->
              <!--                    @click="openVideoPlayer()"-->
              <!--                  >-->
              <!--                    <span> راهنما </span>-->
              <!--                    <svg-->
              <!--                      xmlns="http://www.w3.org/2000/svg"-->
              <!--                      width="20"-->
              <!--                      height="20"-->
              <!--                      fill="currentColor"-->
              <!--                      class="bi bi-info-circle info-secondary-text"-->
              <!--                      viewBox="0 0 16 16"-->
              <!--                    >-->
              <!--                      <path-->
              <!--                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"-->
              <!--                      />-->
              <!--                      <path-->
              <!--                        d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"-->
              <!--                      />-->
              <!--                    </svg>-->
              <!--                  </button>-->
              <!--                </b-col>-->
            </b-container>
          </b-container>
        </b-col>
      </b-row>
      <DesktopLayoutHelperNewVersion v-else-if="!getMobileLayout">
        <template v-slot:body>
          <b-container class="m-1 p-1 pl-0 ml-0">
            <b-row class="fill-width">
              <b-col cols="6" lg="7">
                <b-row v-if="getSiteRatesDisplayCondition">
                  <b-col cols="12" class="text-end new-title-color">
                    {{ $translate("eachVouchersDollarBuyPrice") }}:
                    <strong class="alert-text">
                      {{
                        getPerfectMoneyCurrentPrice | commaSep | persianDigit
                      }}
                    </strong>
                  </b-col>
                </b-row>
                <b-row class="flex-vertical-align py-4">
                  <b-col
                    cols="12"
                    md="10"
                    lg="8"
                    class="input-title-text new-title-color"
                  >
                    {{ $translate("vouchersNumber") }}: ({{
                      $translate("characterNumber23")
                    }})
                  </b-col>
                  <b-col cols="12">
                    <b-input
                      :placeholder="$translate('enterYourVouchersNumber')"
                      class="direction-rtl new-form-control text-end"
                      v-mask="'NNN-NNNN-NNNN-NNNN-NNNN-NNNN'"
                      mask="false"
                      v-model="voucherNumber"
                    ></b-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex justify-content-start py-3">
                    <button
                      type="button"
                      class="font-weight-bold border-none background-transparent"
                    >
                      <span class="steel-blue-text">
                        {{ $translate("helper") }}
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-info-circle steel-blue-text"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                        />
                        <path
                          d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                        />
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="6"
                lg="5"
                align-self="center"
                class="d-flex justify-content-center flex-column pl-0"
              >
                <b-container
                  class="p-0 m-0 mt-2 height-fit-content captcha-row"
                >
                  <b-row
                    class="flex-vertical-align justify-content-center mb-3 pt-2"
                  >
                    <b-col
                      cols="9"
                      class="input-title-text new-title-color pb-2"
                    >
                      {{ $translate("securityCode") }}:
                    </b-col>
                    <b-col cols="9">
                      <b-input
                        :placeholder="
                          $translate('enterTheSecurityCodeInTheContainerBelow')
                        "
                        class="direction-ltr new-form-control text-end py-2"
                        id="voucherNumber"
                        v-mask="'####'"
                        mask="false"
                        v-model="captchaInput"
                      ></b-input>
                    </b-col>
                  </b-row>
                  <b-container class="my-4">
                    <b-row class="align-items-center justify-content-center">
                      <b-col align-self="center" cols="8">
                        <b-row
                          class="align-items-center justify-content-center captcha-row"
                        >
                          <b-col
                            cols="10"
                            class="d-flex justify-content-center"
                          >
                            <!--Captcha Image-->
                            <b-spinner
                              variant="primary"
                              v-if="getCaptchaImagePending"
                              class="mx-5 my-2"
                            ></b-spinner>
                            <b-img
                              width="150px"
                              :src="imageBase64"
                              v-if="!getCaptchaImagePending"
                            />
                            <!--Captcha Image-->
                          </b-col>
                          <b-col
                            cols="2"
                            class="cursor-pointer justify-content-center d-flex p-0 border-right-1px"
                            @click="getCaptchaImage"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="currentColor"
                              class="bi bi-arrow-clockwise"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                              />
                              <path
                                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                              />
                            </svg>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-container>
                <b-row class="flex-centering mt-4">
                  <b-col cols="4">
                    <button
                      type="button"
                      class="decline-button"
                      @click="cancelPayment"
                    >
                      {{ $translate("cancel") }}
                    </button>
                  </b-col>
                  <b-col cols="8">
                    <button
                      type="button"
                      class="btn go-to-next-button"
                      @click="submitInfo()"
                    >
                      {{ $translate("payment") }}
                    </button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </DesktopLayoutHelperNewVersion>
    </transition>
    <!--    <VideoPlayer v-if="showVideo" @closeVideoClickedOutSide="clickedOutSideOfVideo" :videoAddress="videoAddress"/>-->
  </div>
</template>

<script>
import DesktopLayoutHelperNewVersion from "@/components/DesktopLayoutHelperNewVersion";
import HeaderNewVersion from "@/components/HeaderNewVersion";
import { mapGetters } from "vuex";
import { vouchersMixin } from "../../../mixins/VouchersMixin";

export default {
  name: "perfectMoneyNewVersion",
  components: { DesktopLayoutHelperNewVersion, HeaderNewVersion },
  // components: {
  // VideoPlayer,
  // },
  mixins: [vouchersMixin],
  computed: {
    ...mapGetters(["getMobileLayout"]),
  },
};
</script>

<style scoped>
.input-title-text {
  font-size: 0.76rem;
  padding-bottom: 3px;
  font-weight: bold;
}

.flex-vertical-align {
  display: flex;
  align-items: center;
}
.decline-button {
  border-radius: 10px;
  background: #dedede;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.08);
  width: 100%;
  padding: 5px 8px;
  border: 1px solid lightgrey;
}
.go-to-next-button {
  width: 100%;
  padding: 5px;
  border: none !important;
  border-radius: 10px;
  background-color: var(--dodger-blue);
  color: var(--white);
}
.captcha-row {
  border-radius: 10px;
  border: 2px solid #e7e7e7;
}
.height-fit-content {
  height: fit-content;
}
.border-right-1px {
  border-right: 2px solid #e7e7e7;
}

.flex-centering {
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-button {
  width: 100%;
  padding: 5px;
  border: none !important;
  border-radius: 10px;
  background-color: var(--info-primary);
  color: var(--info-secondary);
}

.newVersionTextClass {
  color: black !important;
}

.new-version-button {
  border-radius: 5px !important;
}

.background-dark-green {
  background-color: #1aaf29 !important;
}

.second-version-inputs {
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 1px solid lightgrey !important;
}
</style>
